import styled from "styled-components";

export const IconsBar = styled.div`
  display: flex;
  margin-right: 12px;
`;

export const IconArea = styled.div<{ $color?: string | false }>`
  margin-right: -12px;
  border-radius: 24px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${({ $color }) => $color || "var(--fill-secondary)"};
  display: flex;
  align-items: center;
  justify-content: center;
  .active & {
    svg {
      path {
        fill: #fff;
      }
    }
  }
  svg {
    width: 16px;
    height: 16px;
    path {
      fill: var(--text-primary);
    }
  }
`;
